export default {"src":"/_next/static/media/apple-logo-black.cd2606cb.svg","height":1000,"width":814,"blurWidth":0,"blurHeight":0};